import { RouteConfig } from 'vue-router';

import { permissionHelp } from '../Middleware/permission/Help';

export const NAME_ROUTES_HELP = {
  HELP: 'help',
  TOOLS: 'tools',
  FAQ: 'faq'
};

export const Help: Array<RouteConfig> = [
  {
    path: '/ajuda',
    component: () => import('@/layouts/Default/index.vue'),
    beforeEnter: permissionHelp,
    redirect: '/ajuda/ferramentas',
    children: [
      {
        path: 'ferramentas',
        component: () => import('@/pages/Help/Help.vue'),
        children: [
          {
            path: '',
            name: NAME_ROUTES_HELP.TOOLS,
            component: () => import('@/pages/Help/pages/Tools/Tools.vue'),
            meta: { title: 'Ferramentas' }
          }
        ]
      },
      {
        path: 'faq',
        component: () => import('@/pages/Help/Help.vue'),
        children: [
          {
            path: '',
            name: NAME_ROUTES_HELP.FAQ,
            component: () => import('@/pages/Help/pages/Faq/Faq.vue'),
            meta: { title: 'FAQ' }
          }
        ]
      }
    ]
  }
];
